import { createSlice } from '@reduxjs/toolkit';

const popupSlice = createSlice({
  name: 'popup',
  initialState: { message: '', visible: false },
  reducers: {
    showPopupMessage: (state, action) => {
      state.message = action.payload;
      state.visible = true;
    },
    hidePopupMessage: (state) => {
      state.message = '';
      state.visible = false;
    }
  }
});

export const { showPopupMessage, hidePopupMessage } = popupSlice.actions;
export default popupSlice.reducer;
